import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { userType } from 'src/app/constants/global-constants';
import { ICreateRoomBody, ICreateRoomResponse, IDashboardMidwifePayload } from 'src/app/models/dashboard.models';
import { AuthService } from 'src/app/services/auth.service';
import { ChatService } from 'src/app/services/chat.service';
declare var $: any;
@Component({
  selector: 'app-profile-detail',
  templateUrl: './profile-detail.component.html',
  styleUrls: ['./profile-detail.component.scss']
})
export class ProfileDetailComponent implements OnInit {

  userType = userType;
  @Input() midwife: IDashboardMidwifePayload;
  loggedIn: boolean;
  loggedInUserId: number | undefined;
  constructor(public authService: AuthService,
    private chatService: ChatService,
    private router: Router) {
    this.loggedInUserId = this.authService.getUserID();
   }

  ngOnInit(): void {
    this.loggedIn = this.authService.user?.userType != undefined ? true : false;
    this.midwife.serviceAreas = this.midwife.serviceAreas.split(",");
  }

  createRoom(){
    if (!this.loggedIn) {
      var midwifeId = this.midwife.midwifeId;
      $('#login-modal').on('show.bs.modal', function(e) {

        //get data-id attribute of the clicked element
        e.target.setAttribute('data-midwifeid', midwifeId);
      });
      $('#login-modal').modal('show');
      return;
    }
    if(this.loggedInUserId && this.loggedInUserId != this.midwife.userId)
    {
      let body: ICreateRoomBody = {
        roomId: 'room-uid1-'+this.loggedInUserId+'-uid2-'+this.midwife.userId,
        userid1: this.loggedInUserId,
        userid2: this.midwife.userId
      }

      this.chatService.createChatRoom(body)
      .subscribe((res: ICreateRoomResponse)=>{
        console.log("Room Created Successfully:", res.payload);
        this.router.navigate(['/chat'], { queryParams: { roomId: body.roomId }});
      },err=>{
        console.error("Room Creation Error:", err.error.errorMessage);
        let roomId = String(err.error.errorMessage).slice(69);
        this.router.navigate(['/chat'], { queryParams: { roomId: roomId }});
      });
    }
  }

}
